import { config, handleResponse } from '../../_helpers';

export const waiverServices = {
    createWaivedCharge,           
    searchWayBillBooking,            
    getListWaivedCharges,   
    getWaivedId,            
    updateWaivedStatus,     
    updateWaived,         
    deleteRevision,   
    getListWaivedChargesForEndorsed,        
}
function createWaivedCharge(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/WayBillWaiveCharges/createWaivedCharge`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/WayBillWaiveCharges/createWaivedChargeWithFileUpload`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/WayBillWaiveCharges/createWaivedChargeWithFileUploadV1`, requestOptions).then(handleResponse);
}
function updateWaivedStatus(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/WayBillWaiveCharges/updateWaivedStatus`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/WayBillWaiveCharges/updateWaivedStatusV2`, requestOptions).then(handleResponse);
}
function updateWaived(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/WayBillWaiveCharges/updateWaived/${id}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/WayBillWaiveCharges/updateWaivedWithFileUpload/${id}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/WayBillWaiveCharges/updateWaivedWithFileUploadV1/${id}`, requestOptions).then(handleResponse);
}
function deleteRevision(payload) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/WayBillWaiveCharges/deleteRevision`, requestOptions).then(handleResponse);
}
function searchWayBillBooking(bookingRef) {
    const requestOptions = {
        method: 'GET'
    };
        return fetch(`${config.apiUrl}/WayBillWaiveCharges/searchWayBillBooking?search=${bookingRef}`, requestOptions).then(handleResponse);
}
function getListWaivedCharges(userId, isApprover, status, skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/WayBillWaiveCharges/getListWaivedCharges?UserId=${userId}&isApprover=${isApprover}&status=${status}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/WayBillWaiveCharges/getListWaivedCharges?UserId=${userId}&isApprover=${isApprover}&status=${status}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getWaivedId(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/WayBillWaiveCharges/getWaivedId/${id}`, requestOptions).then(handleResponse);
}
function getListWaivedChargesForEndorsed(userId, status, skip, take, search, isEndorser) {
    const requestOptions = {
        method: 'GET'
    };
    // if (search) {
    //     return fetch(`${config.apiUrl}/WayBillWaiveCharges/getListWaivedChargesForEndorsed?UserId=${userId}&status=${status}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    // }
    // else {
    //     return fetch(`${config.apiUrl}/WayBillWaiveCharges/getListWaivedChargesForEndorsed?UserId=${userId}&status=${status}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    // }
    // if (search) {
    //     return fetch(`${config.apiUrl}/WayBillWaiveCharges/getListWaivedChargesForEndorsedV1?UserId=${userId}&status=${status}&skip=${skip}&take=${take}&search=${search}&isEndorser=${isEndorser}`, requestOptions).then(handleResponse);
    // }
    // else {
    //     return fetch(`${config.apiUrl}/WayBillWaiveCharges/getListWaivedChargesForEndorsedV1?UserId=${userId}&status=${status}&skip=${skip}&take=${take}&isEndorser=${isEndorser}`, requestOptions).then(handleResponse);
    // }
    if (search) {
        return fetch(`${config.apiUrl}/WayBillWaiveCharges/getListWaivedChargesForEndorsedV2?UserId=${userId}&status=${status}&skip=${skip}&take=${take}&search=${search}&isEndorser=${isEndorser}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/WayBillWaiveCharges/getListWaivedChargesForEndorsedV2?UserId=${userId}&status=${status}&skip=${skip}&take=${take}&isEndorser=${isEndorser}`, requestOptions).then(handleResponse);
    }
}